import React from "react";
import * as Yup from "yup";
import PropTypes from "prop-types";

import RenderFields from "Components/RenderFields";

const sealMeterKeys = [
  "meterBodySealLeftBottom",
  "meterBodySealLeftTop",
  "meterBodySealRightTop",
  "meterBodySealRightBottom",
  "meterTerminalCoverSealLeft",
  "meterTerminalCoverSealRight",
  "meterResetButtonSeal",
  "meterBoxOrPanelSealTop",
  "meterBoxOrPanelSealMiddle",
  "meterBoxOrPanelSealBottom",
  "testTerminalBlockSealLeft",
  "testTerminalBlockSealRight",
  "lineCTSealRPhase",
  "lineCTSealYPhase",
  "lineCTSealBPhase",
  "ptChangeOverBoxSealTop",
  "ptChangeOverBoxSealBottom",
];

const isValidValue = (currentValues, currentKey) =>
  sealMeterKeys.some(
    (key) =>
      currentValues[key] &&
      currentKey !== key &&
      currentValues[currentKey] == currentValues[key]
  );

export const inputFields = [
  {
    label: "Meter Body Seal - Left Bottom",
    name: "meterBodySealLeftBottom",
    placeholder: "Enter meter body seal - left bottom",
    validationSchema: Yup.string().test(
      "isValidMeterBodySealLeftBottom",
      "",
      function () {
        const [{ value: current = null } = {}] = this.from || [];

        if (isValidValue(current, "meterBodySealLeftBottom")) {
          return this.createError({
            message: "Value should be unique",
          });
        }
        return true;
      }
    ),
  },
  {
    label: "Meter Body Seal - Left Top",
    name: "meterBodySealLeftTop",
    placeholder: "Enter meter body seal - left top",
    validationSchema: Yup.string().test(
      "isValidMeterBodySealLeftTop",
      "",
      function () {
        const [{ value: current = null } = {}] = this.from || [];

        if (isValidValue(current, "meterBodySealLeftTop")) {
          return this.createError({
            message: "Value should be unique",
          });
        }
        return true;
      }
    ),
  },
  {
    label: "Meter Body Seal - Right Top",
    name: "meterBodySealRightTop",
    placeholder: "Enter meter body seal - right top",
    validationSchema: Yup.string().test(
      "isValidMeterBodySealRightTop",
      "",
      function () {
        const [{ value: current = null } = {}] = this.from || [];

        if (isValidValue(current, "meterBodySealRightTop")) {
          return this.createError({
            message: "Value should be unique",
          });
        }
        return true;
      }
    ),
  },
  {
    label: "Meter Body Seal - Right Bottom",
    name: "meterBodySealRightBottom",
    placeholder: "Enter meter body seal - right bottom",
    validationSchema: Yup.string().test(
      "isValidMeterBodySealRightBottom",
      "",
      function () {
        const [{ value: current = null } = {}] = this.from || [];

        if (isValidValue(current, "meterBodySealRightBottom")) {
          return this.createError({
            message: "Value should be unique",
          });
        }
        return true;
      }
    ),
  },
  {
    label: "Meter terminal cover Seal - Left",
    name: "meterTerminalCoverSealLeft",
    placeholder: "Enter meter terminal cover seal - left",
    validationSchema: Yup.string().test(
      "isValidMeterTerminalCoverSealLeft",
      "",
      function () {
        const [{ value: current = null } = {}] = this.from || [];

        if (isValidValue(current, "meterTerminalCoverSealLeft")) {
          return this.createError({
            message: "Value should be unique",
          });
        }
        return true;
      }
    ),
  },
  {
    label: "Meter terminal cover Seal - Right",
    name: "meterTerminalCoverSealRight",
    placeholder: "Enter meter terminal cover seal - right",
    validationSchema: Yup.string().test(
      "isValidMeterTerminalCoverSealRight",
      "",
      function () {
        const [{ value: current = null } = {}] = this.from || [];

        if (isValidValue(current, "meterTerminalCoverSealRight")) {
          return this.createError({
            message: "Value should be unique",
          });
        }
        return true;
      }
    ),
  },
  {
    label: "Meter Reset button Seal",
    name: "meterResetButtonSeal",
    placeholder: "Enter meter reset button seal",
    validationSchema: Yup.string().test(
      "isValidMeterResetButtonSeal",
      "",
      function () {
        const [{ value: current = null } = {}] = this.from || [];

        if (isValidValue(current, "meterResetButtonSeal")) {
          return this.createError({
            message: "Value should be unique",
          });
        }
        return true;
      }
    ),
  },
  {
    label: "Meter Box/Panel Seal - Top",
    name: "meterBoxOrPanelSealTop",
    placeholder: "Enter meter Box/Panel seal - top",
    validationSchema: Yup.string().test(
      "isValidMeterBoxOrPanelSealTop",
      "",
      function () {
        const [{ value: current = null } = {}] = this.from || [];

        if (isValidValue(current, "meterBoxOrPanelSealTop")) {
          return this.createError({
            message: "Value should be unique",
          });
        }
        return true;
      }
    ),
  },
  {
    label: "Meter Box/Panel Seal - Middle",
    name: "meterBoxOrPanelSealMiddle",
    placeholder: "Enter meter Box/Panel seal - middle",
    validationSchema: Yup.string().test(
      "isValidMeterBoxOrPanelSealMiddle",
      "",
      function () {
        const [{ value: current = null } = {}] = this.from || [];

        if (isValidValue(current, "meterBoxOrPanelSealMiddle")) {
          return this.createError({
            message: "Value should be unique",
          });
        }
        return true;
      }
    ),
  },
  {
    label: "Meter Box/Panel Seal - Bottom",
    name: "meterBoxOrPanelSealBottom",
    placeholder: "Enter meter Box/Panel seal - bottom",
    validationSchema: Yup.string().test(
      "isValidMeterBoxOrPanelSealBottom",
      "",
      function () {
        const [{ value: current = null } = {}] = this.from || [];

        if (isValidValue(current, "meterBoxOrPanelSealBottom")) {
          return this.createError({
            message: "Value should be unique",
          });
        }
        return true;
      }
    ),
  },
  {
    label: "Test Terminal Block Seal - Left",
    name: "testTerminalBlockSealLeft",
    placeholder: "Enter test terminal block seal - left",
    validationSchema: Yup.string().test(
      "isValidTestTerminalBlockSealLeft",
      "",
      function () {
        const [{ value: current = null } = {}] = this.from || [];

        if (isValidValue(current, "testTerminalBlockSealLeft")) {
          return this.createError({
            message: "Value should be unique",
          });
        }
        return true;
      }
    ),
  },
  {
    label: "Test Terminal Block Seal - Right",
    name: "testTerminalBlockSealRight",
    placeholder: "Enter test terminal block seal - right",
    validationSchema: Yup.string().test(
      "isValidTestTerminalBlockSealRight",
      "",
      function () {
        const [{ value: current = null } = {}] = this.from || [];

        if (isValidValue(current, "testTerminalBlockSealRight")) {
          return this.createError({
            message: "Value should be unique",
          });
        }
        return true;
      }
    ),
  },
  {
    label: "Line CT Seal - R Phase",
    name: "lineCTSealRPhase",
    placeholder: "Enter line CT seal - R Phase",
    validationSchema: Yup.string().test(
      "isValidLineCTSealRPhase",
      "",
      function () {
        const [{ value: current = null } = {}] = this.from || [];

        if (isValidValue(current, "lineCTSealRPhase")) {
          return this.createError({
            message: "Value should be unique",
          });
        }
        return true;
      }
    ),
  },
  {
    label: "Line CT Seal - Y Phase",
    name: "lineCTSealYPhase",
    placeholder: "Enter line CT seal - Y Phase",
    validationSchema: Yup.string().test(
      "isValidLineCTSealYPhase",
      "",
      function () {
        const [{ value: current = null } = {}] = this.from || [];

        if (isValidValue(current, "lineCTSealYPhase")) {
          return this.createError({
            message: "Value should be unique",
          });
        }
        return true;
      }
    ),
  },
  {
    label: "Line CT Seal - B Phase",
    name: "lineCTSealBPhase",
    placeholder: "Enter line CT seal - B Phase",
    validationSchema: Yup.string().test(
      "isValidLineCTSealBPhase",
      "",
      function () {
        const [{ value: current = null } = {}] = this.from || [];

        if (isValidValue(current, "lineCTSealBPhase")) {
          return this.createError({
            message: "Value should be unique",
          });
        }
        return true;
      }
    ),
  },
  {
    label: "PT Changeover Box Seal - Top",
    name: "ptChangeOverBoxSealTop",
    placeholder: "Enter PT changeover box seal - top",
    validationSchema: Yup.string().test(
      "isValidPtChangeOverBoxSealTop",
      "",
      function () {
        const [{ value: current = null } = {}] = this.from || [];

        if (isValidValue(current, "ptChangeOverBoxSealTop")) {
          return this.createError({
            message: "Value should be unique",
          });
        }
        return true;
      }
    ),
  },
  {
    label: "PT Changeover Box Seal - Bottom",
    name: "ptChangeOverBoxSealBottom",
    placeholder: "Enter PT changeover box seal - bottom",
    validationSchema: Yup.string().test(
      "isValidPtChangeOverBoxSealBottom",
      "",
      function () {
        const [{ value: current = null } = {}] = this.from || [];

        if (isValidValue(current, "ptChangeOverBoxSealBottom")) {
          return this.createError({
            message: "Value should be unique",
          });
        }
        return true;
      }
    ),
  },
];

const SealDetails = ({ formik }) => (
  <RenderFields formik={formik} inputFields={inputFields} parentKey="seal" />
);

SealDetails.propTypes = {
  formik: PropTypes.object,
};

export default SealDetails;
